import React, { useCallback, useState, useMemo } from 'react'
import { View } from 'react-native'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import useStyles from './useStyles'
import LoadDetail from '../LoadDetail'
import DividerComponent from '../../../Divider'

import { putAssigned } from '../../../../redux/orders/assignedActions'
import ConfirmationDialog from '../../../ConfirmationDialog'
import UpdateOrderForm from '../../../../components/UpdateOrderForm'
import KeyboardView from '../../../KeyboardView'
import { initSelector } from '../../../../redux/initReducer/initSelector'
import { assignedSelector } from '../../../../redux/orders/assignedSelector'
import { usePlatforms } from '../../../../hooks/usePlatforms'

const TractorDetails = ({ driver, tractor, tractorDetails, movementNumber, module }) => {
  const dispatch = useDispatch()
  const { equipmentTypes } = useSelector(initSelector)
  const { loadUpdate } = useSelector(assignedSelector)
  const tractorEquipment = equipmentTypes.find((type) => type.equipment_code === tractor?.equipment_type)

  const { isTablet } = usePlatforms()
  const styles = useStyles(isTablet)

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(null)

  const handleConfirmation = values => setConfirmationDialogOpen(values)

  const handleConfirmationDialog = useCallback((action) => {
    if (action) {
      dispatch(putAssigned(confirmationDialogOpen))
    }
    setConfirmationDialogOpen(null)
  }, [dispatch, confirmationDialogOpen])

  const canEditNumbers = useMemo(() => {
    return module === 'assigned-orders'
  }, [module])

  return (
    <KeyboardView>
      <View style={styles.container}>
        <View style={styles.driverContainer}>
          <View style={styles.driverRow}>
            <LoadDetail
              title='Driver'
              text={driver?.driver_name || '- -'}
            />
            <LoadDetail
              title='Location'
              text={
                tractorDetails?.last_location && tractorDetails.last_location.city && tractorDetails.last_location.state
                  ? `${tractorDetails.last_location.city}, ${tractorDetails.last_location.state}` : '- -'
              }
            />
          </View>
          <View style={styles.driverRow}>
            <LoadDetail
              title='Phone'
              text={driver?.driver_phone_number || '- -'}
            />
            <LoadDetail
              title='Email'
              text={driver?.driver_email || '- -'}
            />
          </View>
        </View>
        <DividerComponent containerStyle={styles.divider} />
        <View style={styles.tractorInformation}>
          <LoadDetail
            icon='Tractor2'
            title='Tractor Type'
            text={tractorEquipment?.description || '- -'}
            style={styles.tractorType}
          />
          {!canEditNumbers && (
            <>
              <LoadDetail
                title='Tractor'
                text={tractor?.tractor_number}
                style={styles.number}
              />
              <LoadDetail
                title='Trailer'
                text={tractor?.trailer_number}
                style={styles.number}
              />
            </>
          )}
        </View>
        {canEditNumbers && (
          <View style={{ marginTop: 10 }}>
            <UpdateOrderForm
              tractor={tractor}
              loadUpdate={loadUpdate}
              movementNumber={movementNumber}
              onSubmit={handleConfirmation}
            />
          </View>
        )}
      </View>
      <ConfirmationDialog
        open={Boolean(confirmationDialogOpen)}
        title='Edit Order'
        description='Are sure you want to save the changes?'
        onClose={handleConfirmationDialog}
      />
    </KeyboardView>
  )
}

TractorDetails.propTypes = {
  driver: PropTypes.object,
  tractor: PropTypes.object,
  tractorDetails: PropTypes.object,
  movementNumber: PropTypes.string,
  module: PropTypes.string
}

TractorDetails.defaultProps = {
  driver: {},
  tractor: {},
  tractorDetails: {},
  movementNumber: '',
  module: ''
}

export default TractorDetails
